import { createContext } from "react";
import { getMachineCentersClusterStatusLocalStorage } from "../../utilities/storageUtilities";
import { IClusterContext, IMachineCentersClusterStatus } from "./ClusterContextInterfaces";

export const initialState: IClusterContext = {
    machineCentersClusterStatus: getMachineCentersClusterStatusLocalStorage() || [],
    handleSetMachineCentersClusterStatus: (value: IMachineCentersClusterStatus[]) => {},
};

export const ClusterContext = createContext(initialState);
